export default __webpack_public_path__ + "static/media/home-events-conference-img-02.e880cc53.jpg";